// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file suppliers/get_supplier.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Supplier, SupplierLifetimeStats, SupplierPayouts } from "./common_pb.js";

/**
 * @generated from message com.neulink.pharmacy.GetSupplierRequest
 */
export class GetSupplierRequest extends Message<GetSupplierRequest> {
  /**
   * Unique identifier for the supplier
   *
   * @generated from field: string id = 1;
   */
  id = "";

  constructor(data?: PartialMessage<GetSupplierRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetSupplierRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSupplierRequest {
    return new GetSupplierRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSupplierRequest {
    return new GetSupplierRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSupplierRequest {
    return new GetSupplierRequest().fromJsonString(jsonString, options);
  }

  static equals(a: GetSupplierRequest | PlainMessage<GetSupplierRequest> | undefined, b: GetSupplierRequest | PlainMessage<GetSupplierRequest> | undefined): boolean {
    return proto3.util.equals(GetSupplierRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.GetSupplierResponse
 */
export class GetSupplierResponse extends Message<GetSupplierResponse> {
  /**
   * The supplier details
   *
   * @generated from field: com.neulink.pharmacy.Supplier supplier = 1;
   */
  supplier?: Supplier;

  /**
   * Lifetime statistics of the supplier
   *
   * @generated from field: com.neulink.pharmacy.SupplierLifetimeStats lifetime_stats = 2;
   */
  lifetimeStats?: SupplierLifetimeStats;

  /**
   * List of payouts associated with the supplier
   *
   * @generated from field: repeated com.neulink.pharmacy.SupplierPayouts payouts = 3;
   */
  payouts: SupplierPayouts[] = [];

  constructor(data?: PartialMessage<GetSupplierResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.GetSupplierResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "supplier", kind: "message", T: Supplier },
    { no: 2, name: "lifetime_stats", kind: "message", T: SupplierLifetimeStats },
    { no: 3, name: "payouts", kind: "message", T: SupplierPayouts, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GetSupplierResponse {
    return new GetSupplierResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GetSupplierResponse {
    return new GetSupplierResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GetSupplierResponse {
    return new GetSupplierResponse().fromJsonString(jsonString, options);
  }

  static equals(a: GetSupplierResponse | PlainMessage<GetSupplierResponse> | undefined, b: GetSupplierResponse | PlainMessage<GetSupplierResponse> | undefined): boolean {
    return proto3.util.equals(GetSupplierResponse, a, b);
  }
}

